export const formatPhone = (input: string) => {
  const num = input.replace(/\D/g, '');

  if ((num.startsWith('7') || num.startsWith('8')) && num.length === 11)
    return `+7 (${num.substring(1, 4)}) ${num.substring(4, 7)}-${num.substring(7, 9)}-${num.substring(9, 11)}`;

  return input;
};
